import './expire-operator-modal.controller.js';



// WEBPACK FOOTER //
// ./components/shop/operators/expire/index.js